var Bookmark, Bookmarks, Collection, _ref,
  __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

Collection = require('models/base/collection');

Bookmark = require('./bookmark');

module.exports = Bookmarks = (function(_super) {
  __extends(Bookmarks, _super);

  function Bookmarks() {
    this.save = __bind(this.save, this);
    this.fetch = __bind(this.fetch, this);
    _ref = Bookmarks.__super__.constructor.apply(this, arguments);
    return _ref;
  }

  Bookmarks.prototype.model = Bookmark;

  Bookmarks.prototype.url = "catalogue_functions/fetch_bookmarks_js.php";

  Bookmarks.prototype.saveUrl = "catalogue_functions/update_bookmarks_js.php";

  Bookmarks.prototype.fetch = function(catalogId, email, password) {
    var fetchString, result,
      _this = this;
    this.trigger('bookmarks:loadStarted');
    fetchString = "catalogue_id=" + catalogId + "&email=" + email + "&password=" + password;
    result = $.ajax({
      dataType: 'json',
      type: 'POST',
      url: this.url,
      data: fetchString
    });
    return result.done(function(response) {
      var resultJSON;
      resultJSON = response;
      if (!resultJSON.length) {
        _this.trigger('bookmarks:loadFailed', {
          error: "Nothing found!"
        });
        return;
      }
      _this.reset(resultJSON);
      return _this.trigger('bookmarks:loadCompleted');
    });
  };

  Bookmarks.prototype.save = function(catalogId, email, password) {
    var result, saveString,
      _this = this;
    this.trigger('bookmarks:saveStarted');
    saveString = ["bookmarks[" + catalogId + "][email]=" + email, "bookmarks[" + catalogId + "][password]=" + password];
    this.each(function(bookmark, index) {
      saveString.push("bookmarks[" + catalogId + "][" + index + "][page]=" + (bookmark.get('page_num')));
      return saveString.push("bookmarks[" + catalogId + "][" + index + "][name]=" + (bookmark.get('text')));
    });
    result = $.ajax({
      dataType: 'json',
      type: 'POST',
      url: this.saveUrl,
      data: saveString.join('&')
    });
    return result.done(function(response) {
      var resultJSON;
      resultJSON = response;
      if ((resultJSON != null ? resultJSON.success : void 0) === 'success') {
        return _this.trigger('bookmarks:saveCompleted');
      } else {
        return _this.trigger('bookmarks:saveFailed');
      }
    });
  };

  return Bookmarks;

})(Collection);
